function resolveDefaultApiBase() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  const defaultPort = process.env.REACT_APP_API_PORT || '3018';
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname}:${defaultPort}/v1`;
  }

  return `http://localhost:${defaultPort}/v1`;
}

const config = {
  api: process.env.REACT_APP_BAMBOO_API || resolveDefaultApiBase(),
  version: process.env.REACT_APP_VERSION || '0.0.1',
};

export default config;
